import { footerLogosReady } from './footerLogos';
import { checkCookiesTooLarge } from './cookiesTooLarge.js';
import { updateAmbassadorMbsyCookie } from './ambassador';
import {
    addEventHandlersToHeaderElements,
    closeMenuLinks,
    initHeaderElements,
    toggleDonorAccountInfo,
} from './headerModule';
import { showAnnualReceiptBanner } from './headerTaxReceiptBanner';
import { keepAliveCart } from './keepAliveCart';

$(document).ready(function () {
    accountCreditsReady();
    updateAmbassadorMbsyCookie();
    checkCookiesTooLarge();
    footerLogosReady();
    headerReady();
    showAnnualReceiptBanner();
    mobileOrFullSiteReady();
    placeholderReady();
    keepAliveCart();
});

$(window).on('signinTriggered', function () {
    showAnnualReceiptBanner();
    window.refreshMiniCartFromServer();
    window.resetAndPersonalizeHeaderElements();
    if (window.isMobileView()) { closeMenuLinks(); }
});

function accountCreditsReady() {
    // Mini-cart populates account credits on first load for cookied donors
    if (!window.isNonBlankCookie('userId')) {
        window.eraseCookie('accountCredits');
    }
    window.displayAccountCreditsTip();

    $('body').on('click.hide-account-credits-tip', function (event) {
        if ($('#account-credits-tip').hasClass('on') && $(event.target).closest('#account-credits-tip').length === 0) {
            toggleAccountCreditsTip();
        }
    });
}

function toggleAccountCreditsTip() {
    $('#account-credits-tip').toggleClass('on');
    if (!$('#account-credits-tip').hasClass('on')) {
        $('#account-credits-tip').blur();
    }
}

function headerReady() {
    $('body').on('click.hide-user-account-links', function (event) {
        if (!window.isMobileView() && $('#user-account-links .subnav').is(':visible') && $(event.target).closest('#user-account-links').length === 0) { toggleDonorAccountInfo(); }
    });

    window.showHideTeacherEmailConfirmBanner();
    window.showHideTeacherSchoolEmailConfirmBanner();
    initHeaderElements();
    addEventHandlersToHeaderElements();

    if (qsParam.introVideo != null) {
        showVideoLightBox(introVideoURL);
    }
    window.setUpUserCookies();
}

function mobileOrFullSiteReady() {
    if (window.isMobileDevice && window.mobileOptimized) {
        if (window.readCookie('mobileOrFullSite') != null && window.readCookie('mobileOrFullSite') === 'full') {
            dcAnalytics.trackEventGANonInteraction([pageName, 'MobileOrFullSite', 'full']);
        }
    }
}

function placeholderReady() {
    const placeholderSupport = ('placeholder' in document.createElement('input'));
    if (!placeholderSupport) {
        $('[placeholder]').focus(function () {
            const input = $(this);
            if (input.val() == input.attr('placeholder')) {
                input.val('');
                input.removeClass('placeholder');
            }
        }).blur(function () {
            const input = $(this);
            if (input.val() == '' || input.val() == input.attr('placeholder')) {
                input.addClass('placeholder');
                input.val(input.attr('placeholder'));
            }
        }).blur().parents('form').submit(function () {
            $(this).find('[placeholder]').each(function () {
                const input = $(this);
                if (input.val() == input.attr('placeholder')) {
                    input.val('');
                }
            });
        });
    }
}
